import script from "./IndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=17814de5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17814de5"]])

export default __exports__